import script from "./PriceAndQuoteButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceAndQuoteButton.vue?vue&type=script&setup=true&lang=ts"

import "./PriceAndQuoteButton.vue?vue&type=style&index=0&id=63aabdbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63aabdbe"]])

export default __exports__